import { getAppConfigSetting, requests } from 'utils';
import { SUSPEND_WIRES_URL } from './constants';

export function suspendWireRequest(transferId, payload, action) {
  return requests.put(`${SUSPEND_WIRES_URL(getAppConfigSetting('apiUrl'), transferId, action)}`, JSON.stringify(payload));
}



// WEBPACK FOOTER //
// ./src/services/suspendWire/api.js